import React, {useEffect, useState} from 'react';
import EmptyData from "../../../../resources/icon/empty-data.png";
import DetailLinkedPagination from "../../../../components/detailLayout/DetailLinkedPagination";
import {getRentalAssetHistories} from "../../../../api/lifecycle/rental/rentalHistoryService";
import {useSelector} from "react-redux";

// 대여자산 이력
const RentalAssetHistory = ({rentalAssetId}) => {
    const [rentalHistories, setRentalHistories] = React.useState([]);
    const [pageable, setPageable] = useState({
        sort: "createdAt",
        desc: true,
        size: 5,
        totalElements: 0,
        totalPages: 0,
        page: 0
    });

    const refresh = useSelector(state => state.status.refreshContent);

    useEffect(() => {
        handleCallData();
    }, [rentalAssetId, refresh, pageable.page]);

    const handleCallData = async () => {
        if (rentalAssetId) {
            const data = {rentalAssetId, pageable};
            await getRentalAssetHistories(data, (data) => {
                setRentalHistories([...data.content]);
                setPageable((prev) => (
                    {...prev, totalElements: data.totalElements, totalPages: data.totalPages, page: data.number})
                );
            });
        }
    }

    return (
        <>
            <div className={'w-full'} style={{flex: 1, minHeight: 0}}>
                <div style={{height: "100%", overflowY: "auto"}}>
                    <table className="w-full table-fixed border-collapse">
                        <thead>
                        <tr>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>순서</span>
                            </th>
                            <th className="w-[70%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>이력 내용</span>
                            </th>
                            <th className="w-[20%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>이력 날짜</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {rentalHistories.length > 0 ? (
                            <>
                                {rentalHistories.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="w-[10%] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{(pageable.totalElements - index) - (pageable.page * pageable.size)}</span>
                                        </td>
                                        <td className="w-[70%] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{item?.content}</span>
                                        </td>
                                        <td className="w-[20%] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{item?.createdAt}</span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr className="border border-[#e2e8f0] overflow-y-auto"
                                style={{height: "calc(100vh - 47rem)"}}>
                                <td className="w-full" colSpan={3}>
                                    <img src={EmptyData} className="w-[50px] m-auto mb-3"/>
                                    <div className={"text-center"}>데이터가 없습니다.</div>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
            {rentalHistories.length > 0 && (
                <DetailLinkedPagination
                    pageable={{
                        pageNumber: pageable.page,
                        totalPages: pageable.totalPages,
                        totalElements: pageable.totalElements,
                        pageSize: pageable.size,
                    }}
                    onPageChange={(next) => setPageable((prev) => ({...prev, page: next.pageNumber}))}
                />
            )}
        </>
    );
};

export default RentalAssetHistory;